import { i18n } from '@shared/i18n';

const tabsConfig = {
  charges: {
    isDisabled: false,
    type: 'charges',
    label: i18n('entities.stripeIncome.tabs.charges'),
    index: 0,
    routerPush: {
      name: 'stripeIncome',
      params: {
        tabName: 'charges'
      }
    },
  },
  payouts: {
    isDisabled: false,
    type: 'payouts',
    label: i18n('entities.stripeIncome.tabs.payouts'),
    index: 1,
    routerPush: {
      name: 'stripeIncome',
      params: {
        tabName: 'payouts'
      }
    },
  },
  // installments: {
  //   isDisabled: true,
  //   type: 'installments',
  //   label: i18n('entities.stripeIncome.tabs.installments'),
  //   index: 1,
  //   routerPush: {
  //     name: 'installments',
  //   },
  // },
};

export default {
  namespaced: true,

  state: {
    tabIndex: 0
  },

  getters: {
    tabs: () => tabsConfig,
    tabIndex: state => state.tabIndex
  },

  mutations: {
    SET_TAB_INDEX(state, payload) {
      state.tabIndex = payload;
    }
  },

  actions: {
    doResetTabs({ commit } ) {
      commit('SET_TAB_INDEX', 0);
    },
    setTabIndex({ commit }, tabIndex ) {
      commit('SET_TAB_INDEX', tabIndex);
    }
  },
};
